import BaseModel from '../base/BaseModel.model';
import User from '../security/user.model';

export default class EvaluationUserCompletedUI extends BaseModel {

    public user: User | null = null;
    public isCompleted: boolean = false;
    public motivoEvaluacion: string = "";

    constructor(){
        super();
        this.init();
    }

    init(){}
}